import axios from '../index';

// 邮箱认证
export const verifyEmail = (data) => {
  return axios.post('/api/company/verifyEmail', data);
};

// 邮箱认证码
export const sendVerifyCode = (data) => {
  return axios.post('/api/company/sendVerifyCode', data);
};

// 上传license
export const uploadLicense = (data) => {
  return axios.post('/api/company/uploadLicense', data);
};

// 认证license
export const verifyLicense = (data) => {
  return axios.post('/api/company/verify', data);
};

// Verify Your Business 下拉列表
export const companySearch = (name) => {
  return axios.get('/api/common/company/searchByName?name=' + name);
};
